import React, { useState } from "react"
import Header from "../components/header"
import { Link, graphql } from "gatsby"
import Img from "gatsby-image"
import "../styles/card-grid.css"
import { FaNotEqual } from "react-icons/fa"

export default function TutorialPage({ data }) {
  const [ctag, SetCTag] = useState("");

  //sets the current tag, selectively hides on render side
  function handleClick(tag) {
    // alert("this is "+ tag);
    SetCTag(tag);
    console.log(ctag);
  }

  return (
    <div>
      <Header />
      <div className="columns is-centered is-mobile">
        <div className="column is-6">
          <h1 class="title my-5">Tutorials</h1>
          <h4 class="subtitle">{data.allMarkdownRemark.totalCount} high-quality and totally free game development, motion graphics and programming posts.</h4>
          <div class="card-grid">
            {data.allMarkdownRemark.edges
              .filter(({ node }) => ctag == "" ? node : (node.frontmatter.tags.includes(ctag)))
              .map(({ node }) => (
                //start of card
                <div key={node.id} className="md-6 card equal-height">
                  <Link to={node.fields.slug}>
                    <div className="card-image">
                      <figure className=" image is-16by9 pt-0">
                        <Img fluid={node.frontmatter.featuredImage.childImageSharp.fluid}></Img>
                      </figure>
                    </div>
                    <div className="card-header">
                      <p className="card-header-title is-centered">{node.frontmatter.title}{" "}</p>
                    </div>
                    <div className="card-content mb-6">
                      <p className="subtitle">{node.frontmatter.excerpt}</p>
                      <div>
                        {node.frontmatter.tags.map((tag, i) => [
                          <span className="tag is-warning is-rounded m-1" key={i} onClick={() => handleClick(tag)}>
                            #{tag}
                          </span>
                        ])}
                      </div>
                    </div>
                    <div className="xcard-footer mb-2">
                      <span className="subtitle is-6 mb-2 p-4 has-text-right">{node.frontmatter.date}</span>
                    </div>
                  </Link>
                </div>
                //end of card
              ))}
          </div>
        </div>
        <div className="column is-2 ml-6">
          <p className="title my-5">Tags</p>
          <div class="buttons">
            <button className="button is-primary is-rounded is-small m-1" onClick={() => handleClick("")}>
              <p className="is-size-6">all ({data.allMarkdownRemark.totalCount})</p>
            </button>
            {data.allMarkdownRemark.group.map(tag => ([
              <button key={tag.fieldValue} className="button is-small is-rounded is-warning m-1" onClick={() => handleClick(tag.tag)}>
                <p className="is-size-6">{tag.tag} ({tag.totalCount})</p>
              </button>
            ]))}
          </div>
        </div>
      </div>
    </div>
  );
}


export const query = graphql`
      query {
        allMarkdownRemark(
          filter: {frontmatter: {type: {in: "tutorial"}}}
          sort: {order: DESC, fields: frontmatter___date}
          ) {
          group(field: frontmatter___tags) {
            tag: fieldValue
            totalCount
          }
          totalCount
          edges {
            node {
              id
              frontmatter {
                title
                tags
                type
                excerpt
                difficulty
                date(formatString: "DD MMM YYYY")
                featuredImage {
                  childImageSharp {
                    fluid(maxWidth: 800) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
              fields {
                slug
              }
              excerpt
            }
          }
        }
      }
    `